import React, { PureComponent } from 'react'
import { func, arrayOf } from 'prop-types'
import Button from '@active/react-ui/Button'
import paymentMethodTypes, { paymentMethodPropType } from '../../../payments/components/common/paymentMethodTypes'
import PaymentMethodDetail from '../../../payments/components/common/PaymentMethodDetail'
import PaymentMethodAccordion from '../../../payments/components/common/PaymentMethodAccordion'
import I18nMessage from '../../../common/I18nMessage'
import DashedLineHr from '../../../common/DashedLineHr'
import { sortbyBuilder } from '../../../../shared/utils/commonUtils'
import '../wallet.components.scss'
import './PaymentMethodList.scss'

class PaymentMethodList extends PureComponent {
  static propTypes = {
    paymentMethods: arrayOf(paymentMethodPropType),
    handleEditPaymentMethod: func.isRequired,
    handleDelPaymentMethod: func.isRequired,
    handleChangePrimaryMethod: func.isRequired,
  }

  static defaultProps = {
    paymentMethods: [],
  }

  handleClick = (handleFunc, currentTarget) => {
    const { paymentMethods } = this.props
    const dataId = currentTarget.getAttribute('data-id')
    const selected = paymentMethods.find(paymentMethod => `${paymentMethod.id}` === dataId)
    if (selected) {
      handleFunc(selected)
    }
  }

  handleEdit = ({ currentTarget }) => {
    const { handleEditPaymentMethod } = this.props
    this.handleClick(handleEditPaymentMethod, currentTarget)
  }

  handleDelete = ({ currentTarget }) => {
    const { handleDelPaymentMethod } = this.props
    this.handleClick(handleDelPaymentMethod, currentTarget)
  }

  handleChange = ({ currentTarget }) => {
    const { handleChangePrimaryMethod } = this.props
    this.handleClick(handleChangePrimaryMethod, currentTarget)
  }

  renderItem = info => (
    <div key={info.id} className="passport__wallet-list--item">
      <PaymentMethodAccordion
        enableIcon
        paymentMethod={info}
        content={(
          <div className="passport__wallet-list--buttons">
            {info.primary
              ? (
                <div className="passport__wallet-list--primary-your passport__wallet-list--primary-in-list">
                  <i className="ic-check-o" />
                  <I18nMessage id="passport.wallet.primary.your" />
                </div>
              )
              : (
                <Button data-id={info.id} onClick={this.handleChange} type="secondary" className="passport__wallet-list--make-primary">
                  <I18nMessage id="passport.wallet.primary.make" />
                </Button>
              )}
            <div className="passport__wallet-list--buttons-main">
              <Button data-id={info.id} onClick={this.handleDelete} type="secondary" className="passport__wallet-list--button">
                <I18nMessage id="passport.common.btn.delete" />
              </Button>
              <Button data-id={info.id} onClick={this.handleEdit} type="primary" className="passport__wallet-list--button">
                <I18nMessage id="passport.common.btn.edit" />
              </Button>
            </div>
          </div>
)}
      />
    </div>
  )

  render() {
    const { paymentMethods } = this.props

    let primary
    const typedMap = {}
    paymentMethods.map(paymentMethodTypes.convert).sort(sortbyBuilder([{
      field: a => a.getEnumType(),
      asc: true,
    }, {
      field: a => a.primary,
    }, {
      field: a => new Date(a.modifiedDate),
    }])).forEach(paymentMethod => {
      if (paymentMethod.primary) {
        primary = paymentMethod
      }
      const type = paymentMethod.getEnumType()
      if (type) {
        typedMap[type] = typedMap[type] || []
        typedMap[type].push(paymentMethod)
      }
    })

    if (!paymentMethods.length) {
      return (
        <div className="passport__wallet__components passport__wallet-list">
          <div className="passport__wallet-list--empty">
            <I18nMessage id="passport.wallet.list.empty" />
          </div>
        </div>
      )
    }

    return (
      <div className="passport__wallet__components passport__wallet-list">

        {primary
          ? (
            <div className="passport__wallet-list--primary-header">
              <h2 className="passport__wallet-list--primary-title">
                <I18nMessage id="passport.wallet.view.primary.title" />
              </h2>
              <div className="passport__wallet-list--primary">
                <PaymentMethodDetail
                  paymentMethod={primary}
                  enableIcon
                  content={(
                    <div className="passport__wallet-list--primary-your">
                      <i className="ic-check-o" />
                      <I18nMessage id="passport.wallet.primary.your" />
                    </div>
                )}
                />
              </div>
            </div>
          )
          : (
            <div className="passport__wallet-list--primary-empty">
              <I18nMessage id="passport.wallet.list.primary.empty" />
            </div>
          )}

        <DashedLineHr />

        <div className="passport__wallet-list--groups">
          {Object.keys(typedMap).map(type => (
            <div key={type} className="passport__wallet-list--group">
              <h2 className="passport__wallet-list--group-title">
                <I18nMessage id={`passport.wallet.group.title.${type}`} />
              </h2>

              {typedMap[type].map(this.renderItem)}
            </div>
          ))}
        </div>

      </div>
    )
  }
}

export default PaymentMethodList
